module.exports = __webpack_public_path__ + "eca4189e8ecd25b24c6da76438cf1481.png";